<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="New Attribute" scrollable hide-footer size="sm">
            <template v-slot:modal-title>
                <span>New Attribute:</span>
            </template>

            <b-form @submit.stop.prevent="createAttribute">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="create.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [

		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-inventory-attributes-create-attribute',
                create: {},
                submitting: 0,
			}
		},

		methods: {
            createAttribute() {
                this.submitting = 1
                let createData = this.create

                let url = 'api/inventory/attributes/createattribute'
                axios.post(url, {
                    createData
                })
                .then((res) => {
                    this.submitting = 0

                    let status = res.data.status
                    if (status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Attribute Created', 'Attribute created successfully!')
                        this.$emit('getAttributes')
                    } else if (status == 'duplicate') {
                        this.showAlertBox('success', 'Duplicate Attribute', 'Attribute already exists! Please try something else!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error creating attribute!')
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {

		}
	}
</script>
<style lang="scss">
    #modal-inventory-attributes-create-attribute {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
